import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-plus',
  standalone: true,
  templateUrl: './icon-plus.component.html',
  styleUrl: './icon-plus.component.css'
})
export class IconPlusComponent { }
